module.exports = __webpack_public_path__ + "static/media/burger-icon.98a05e92.svg";